import { Input } from "antd";
import { BsFillDiagram2Fill } from "react-icons/bs";
import styled from "styled-components";
import { AppPartType } from "../../../types";
import { FC } from "react";
import { SelectedOrganizationList } from "../../Modal/SettingComponents/OrganizationSelectionSetting/OrganizationSelect";
import { RiOrganizationChart } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";

const Styles = styled.div`
  display: flex;
  .branch-icon {
    display: flex;
    align-items: center;
    background: #174a83;
    padding: 0 5px;
    border: 0.5px solid #f7f9fa;
    border-radius: 3px;
  }

  input {
    height: 36px;
  }
`;
const SelectList = styled.div`
  height: 75px;
  overflow-y: auto;
  padding: 7px;
  .select-option {
    line-height: 24px;
    color: #000;
    display: flex;
    align-items: center;
    svg {
      margin-right: 3px;
    }
    &.checked {
      color: #83b1e7;
    }
  }
`;
type PropsType = {
  appPart: AppPartType;
};
const DivisionSelection: FC<PropsType> = ({ appPart }) => {
  return appPart?.item_config_data.preset_division &&
    appPart?.item_config_data.preset_divisions &&
    appPart?.item_config_data.preset_divisions.length > 0 ? (
    <SelectList>
      {appPart?.item_config_data.preset_divisions?.map((o) => (
        <div className="select-option" key={o.name}>
          {o.name}
        </div>
      ))}
    </SelectList>
  ) : (
    <div style={{ height: "100%" }}>
      <Styles style={{ height: "100%" }}>
        <Input.Search disabled />
        <div className="branch-icon">
          <BsFillDiagram2Fill size={20} color="#fff" />
        </div>
      </Styles>
      {appPart.item_config_data?.default_divisions?.map((o) => (
        <SelectedOrganizationList key={o.id}>
          <div className="o-name">
            <RiOrganizationChart size={20} color="#174a83" />
            <div>{o.name}</div>
          </div>
          <AiOutlineClose className="o-close" />
        </SelectedOrganizationList>
      ))}
    </div>
  );
};

export default DivisionSelection;
